import { useCallback, useState } from 'react'

export default function useModal(defaultShow = false) {
  const [isShow, setIsShow] = useState(defaultShow)

  const open = useCallback(() => {
    setIsShow(true)
  }, [])

  const close = useCallback(() => {
    setIsShow(false)
  }, [])

  return { isShow, open, close }
}
